import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category/category.service';
@Component({
  selector: 'app-marques',
  templateUrl: './marques.component.html',
  styleUrls: ['./marques.component.css']
})
export class MarquesComponent implements OnInit {
  fornisseurs
  constructor(private categoryService:CategoryService) { }

  ngOnInit(): void {
    this.categoryService.allCategories().subscribe(res =>{
       this.fornisseurs = res['fournisseurs']
    })
  }

}
